import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Row, Col, Typography, Card, Table } from 'antd'
import { ActionButton, ModuleTopHeading } from '../../components'
import { actionsApi, TableLoader } from '../../shared'
import { MasterPortalDrawer, ViewPortalsModal } from '../../components/MasterPortal'
import { yesNo } from '../../shared/lookups'
import { OrderedListOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

const MasterPortal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { data, loading, pagination } = useSelector(state => state?.addEditBox)
  const [visible, setVisible] = useState(false)
  const [visibleModal, setVisibleModal] = useState(false)

  useEffect(() => {
    dispatch(actionsApi?.viewAllAndroidBoxes({ androidBoxAddedFor: 1, masterPortal: 1, pageNo: 1, pageSize: pagination?.pageSize }))
  }, [])

  const call = (pageNo = 1, pageSize = 10) => {
    dispatch(actionsApi?.viewAllAndroidBoxes({ androidBoxAddedFor: 1, masterPortal: 1, pageNo, pageSize }))
  }

  const columns = [
    {
      title: <Text>{t('Serial #')}</Text>,
      dataIndex: 'serialNo',
      key: 'serialNo',
    },
    {
      title: <Text>{t('Box Name')}</Text>,
      dataIndex: 'boxName',
      key: 'boxName',
    },
    {
      title: <Text>{t('Mac Address')}</Text>,
      dataIndex: 'macAddress',
      key: 'macAddress',
      render: col => <Text className='brand-color'>{col}</Text>,
    },
    {
      title: <Text>{t('Master Portal')}</Text>,
      dataIndex: 'masterPortal',
      render: col => <Text>{yesNo?.find(fin => fin?.id === parseInt(col))?.name}</Text>,
    },
    {
      title: <Text>{t('Action')}</Text>,
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (_, row) => (
        <ActionButton
          title={t('View Portals')}
          className='btn-color-green'
          type='primary'
          icon={<OrderedListOutlined />}
          onClick={() => {
            setVisibleModal(row?.boxName)
            dispatch(actionsApi?.getAndroidBoxPortals(row?.id))
          }}
        />
      ),
    },
  ]

  return (
    <div>
      <Card className='border0'>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <ModuleTopHeading
              name={t('Master Portal')}
              onClick={() => setVisible(true)}
            />
          </Col>
          <Col span={24}>
            <Table
              size='large'
              columns={columns}
              dataSource={data}
              className='table-cover'
              pagination={{
                hideOnSinglePage: true,
                total: pagination?.totalRecords,
                pageSize: pagination?.pageSize,
                defaultPageSize: pagination?.pageSize,
                current: pagination?.pageNo,
                size: 'default',
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: total => <Button>{t('Total')}: {total}</Button>,
              }}
              loading={{
                ...TableLoader,
                spinning: loading,
              }}
            />
          </Col>
        </Row>
      </Card>
      <MasterPortalDrawer
        visible={visible}
        callBack={call}
        onClose={() => setVisible(false)}
      />
      <ViewPortalsModal
        visible={visibleModal}
        onClose={() => {
          setVisibleModal(false)
          dispatch(actionsApi?.androidBoxPortalsResponse([]))
        }}
      />
    </div>
  )
}

export { MasterPortal }
